module.exports = __webpack_public_path__ + "static/img/loading.1e84644.gif";